/** Public brand artwork under `frontend/public/`. */
export const BRAND_ASSETS = {
  logo: '/wm_Logo_1.png',
  logoCosmic: '/wm_logo_cosmic.jpg',
  recruitmentFlyer: '/wm_flyer_neon.png',
  councilIllustration: '/wisemen-council.png',
} as const;
